/**
 * The header's Alerts row and the follow failure line. The follow toggle
 * itself is the header star (`TeamFollowStarButton`, ISSUE-1082).
 *
 * Presentational only: it takes state and callbacks and calls no hook and no
 * SDK, which is what lets its own test drive every one of the four view
 * states with no network.
 */
import { cn, FOCUS_RING } from "@sportsmet/ui";
import type { ReactNode } from "react";

import {
  alertsSummaryLabel,
  FOLLOW_FAILED_TEXT,
  TEAM_ALERTS_ROW_TITLE,
  type typeAlertSwitchRow,
  type typeTeamFollowViewState,
} from "./teamFollowLogic";

export type typeTeamFollowControlProps = {
  viewState: typeTeamFollowViewState;
  isFollowing: boolean;
  alertRows: readonly typeAlertSwitchRow[];
  onOpenAlerts: () => void;
};

export const TeamFollowControl = (
  props: typeTeamFollowControlProps,
): ReactNode => {
  const summary = alertsSummaryLabel({
    isFollowing: props.isFollowing,
    alerts: props.alertRows,
  });

  return (
    <div className="flex flex-col gap-2 border-t border-hairline pt-2">
      {props.viewState === "failed" ? (
        <p data-testid="team-follow-failed" className="text-caption text-error">
          {FOLLOW_FAILED_TEXT}
        </p>
      ) : null}
      <button
        type="button"
        data-testid="team-alerts-row"
        aria-label={`${TEAM_ALERTS_ROW_TITLE}, ${summary}`}
        onClick={props.onOpenAlerts}
        className={cn(
          "flex min-h-touch-target flex-col items-start justify-center text-left",
          FOCUS_RING,
        )}
      >
        <span className="text-body-strong text-ink">
          {TEAM_ALERTS_ROW_TITLE}
        </span>
        <span
          data-testid="team-alerts-summary"
          className="text-caption text-ink-secondary"
        >
          {summary}
        </span>
      </button>
    </div>
  );
};
